/**
 * Messages for the error codes the sign-in service puts on the Google callback
 * (`?error=<code>`, see sf-auth-service src/routes/auth.ts). Only codes listed
 * here are shown by name; anything else gets the generic line, so text from the
 * URL is never echoed onto the page.
 */
const SIGN_IN_ERRORS: Record<string, string> = {
  domain_not_allowed: 'Only ServeFirst staff accounts can sign in with Google here.',
  user_suspended: 'Your account is suspended. Ask an admin to reactivate it.',
  account_inactive: 'Your account has been switched off. Ask an admin if you need it back.',
};

export const GENERIC_SIGN_IN_ERROR = 'Sign-in failed. Please try again.';

/** The line to show for a callback error code, or null when there is no error. */
export const signInErrorMessage = (code: string | null): string | null => {
  if (!code) return null;
  return Object.prototype.hasOwnProperty.call(SIGN_IN_ERRORS, code)
    ? SIGN_IN_ERRORS[code]
    : GENERIC_SIGN_IN_ERROR;
};
